var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._l((_vm.$store.state.favourites),function(row,i){return _c('span',{key:i},[_vm._v(" "+_vm._s(row.Description)+" "),_c('star',{attrs:{"cmpid":row.competitorid,"cmpdesc":row.Description}})],1)})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }